<template>
  <div
    class="user-shortcut"
    @mouseover="hoverOnFlyout"
    @mouseleave="hoverLeaveFlyout"
  >
    <a
      :href="url"
      class="user-shortcut__link"
      :class="[
        type ? `user-shortcut__link--${type}` : '',
        active ? `user-shortcut__link--active` : ''
      ]"
    >
      <span
        v-if="showBadge"
        class="user-shortcut__notification-badge"
        :class="[
          type ? `user-shortcut__notification-badge--${type}` : ''
        ]"
      >
        {{ badgeCount }}
      </span>
      <span
        v-if="label"
        class="user-shortcut__label"
      >
        {{ label }}
      </span>
    </a>
    <div
      class="user-shortcut__flyout user-shortcut__flyout--cart"
      v-show="showFlyout"
    >
      <minicart
        v-if="type === 'cart'"
      />
    </div>
  </div>
</template>

<script>
  import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js';
  import Minicart from '../minicart/minicart.vue';

  export default {
    components: {
      Minicart
    },
    mixins: [
      globalStateComputedMixin
    ],
    props: {
      type: String,
      showBadge: {
        type: Boolean,
        default: false
      },
      badgeCount: {
        type: Number,
        default: 0
      },
      active: {
        type: Boolean,
        default: false
      },
      label: String,
      url: String
    },
    data() {
      return {
        showMiniFlyout: ''
      }
    },
    mounted() {
      this.$store.subscribe(mutation => {
        if (mutation.type === 'showMinicart') {
          let mutationType = mutation.payload.type;
          this.showMiniFlyout = mutationType;
          if (mutationType === 'cart') {
            const self = this;
            setTimeout(() => {
              self.showMiniFlyout = '';
            }, 3000)
          }
        }
      });
    },
    computed: {
      showFlyout() {
        return !!(this.type === 'cart'
          && this.showMiniFlyout === 'cart'
          && this.pageType !== 'cart'
          && (this.cart.shipmentPositions.flatMap(pos => pos.positions) || this.cart.configuratorPositions.length));

      }
    },
    methods: {
      hoverOnFlyout() {
        if (this.type === 'cart') {
          this.showMiniFlyout = this.type;
        }
      },
      hoverLeaveFlyout() {
        this.showMiniFlyout = '';
      }
    }
  };

</script>
